export * from './RecoilTunnel';
export { getRecoilStore, set } from './getStore';
//# sourceMappingURL=index.js.map